interface ColumnPropertiesInterface {
  id: string;
  size?: number;
}

interface ColumnConfigInterface {
  FUNCTIONS: ColumnPropertiesInterface;
  MESSAGE_TYPE: ColumnPropertiesInterface;
  SETTINGS_TIME_BEFORE: ColumnPropertiesInterface;
}

export const COLUMN_CONFIG: ColumnConfigInterface = {
  FUNCTIONS: {
    id: 'Functions',
    size: 200,
  },
  MESSAGE_TYPE: {
    id: 'MessageType',
  },
  SETTINGS_TIME_BEFORE: {
    id: 'SettingsTimeBefore',
    size: 100,
  },
};
